import React, { useState, useEffect } from "react";

import Cargando from "../../Cargando";
import { dbApp } from "../../../firebase/config";
import ListadoPromociones from "./ListadoPromociones";
import Mensaje from "../../Mensaje";

const PromocionesPrincipal = () => {
  const [promociones, setPromociones] = useState([]);
  const [cargando, setCargando] = useState(false);

  const getPromociones = () => {
    setCargando(true);
    const resultadoPromociones = [];
    dbApp
      .collection("promociones")
      .where("estatus", "==", "1")
      .get()
      .then(response => {
        setCargando(false);
        response.forEach(doc => {
          const promocion = doc.data();
          promocion.id = doc.id;
          resultadoPromociones.push(promocion);
        });
        setPromociones(resultadoPromociones);
      })
      .catch(() => {
        setCargando(false);
      });
  };

  useEffect(() => {
    getPromociones();
  }, []);

  let mostrar;

  if (cargando) {
    mostrar = <Cargando />;
  } else if (promociones.length <= 0) {
    mostrar = (
      <div className="mt-5">
        <Mensaje mensaje="No hay promociones." />
      </div>
    );
  } else {
    mostrar = (
      <ListadoPromociones
        promociones={promociones}
        getPromociones={getPromociones}
      />
    );
  }

  return (
    <>
      <div className="d-flex justify-content-between">
        <h3>Promociones</h3>
        <a className="btn btn-light" href="/admin/promocion/agregar">
          <i className="fa fa-plus" aria-hidden="true"></i> Agregar
        </a>
      </div>

      {mostrar}
    </>
  );
};

export default PromocionesPrincipal;
